import axios from 'axios';

export function createClient({
  baseURL = '/api/',
  withCredentials = true,
  ...config
}) {
  return axios.create({
    baseURL,
    withCredentials,
    ...config,
  });
}

export async function safeRequest(request) {
  try {
    const { data } = await request();

    return { data };
  } catch (error) {
    return { error };
  }
}
